import {LitElement, html, css, svg} from 'lit';
import {customElement, property} from 'lit/decorators.js';

@customElement('obi-generator')
export class ObiGenerator extends LitElement {
  @property({type: Boolean}) useCssColor = false;

  private icon = svg`<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M15.1677 14.175V22L21 9.825H16.988V2L11 14.175H15.1677Z" fill="currentColor"/>
<path d="M10.2285 6.18945H6.83008V7.70117H8.45312V9.48828C8.29688 9.51562 8.12891 9.54297 7.94922 9.57031C7.77344 9.59375 7.55664 9.60547 7.29883 9.60547C6.77148 9.60547 6.34375 9.48438 6.01562 9.24219C5.6875 8.99609 5.44727 8.6582 5.29492 8.22852C5.14258 7.79492 5.06641 7.29883 5.06641 6.74023C5.06641 6.15039 5.17188 5.63867 5.38281 5.20508C5.59766 4.76758 5.89844 4.42773 6.28516 4.18555C6.67578 3.94336 7.13477 3.82227 7.66211 3.82227C8.0293 3.82227 8.38086 3.86719 8.7168 3.95703C9.05273 4.04688 9.35156 4.1582 9.61328 4.29102L10.2168 2.83789C9.85742 2.68164 9.45703 2.55469 9.01562 2.45703C8.57422 2.35938 8.12695 2.31055 7.67383 2.31055C6.71289 2.31055 5.89844 2.49023 5.23047 2.84961C4.56641 3.20898 4.06055 3.7168 3.71289 4.37305C3.36914 5.0293 3.19727 5.80664 3.19727 6.70508C3.19727 7.66211 3.35156 8.46875 3.66016 9.125C3.96875 9.78125 4.41992 10.2773 5.01367 10.6133C5.60742 10.9492 6.33008 11.1172 7.18164 11.1172C7.79492 11.1172 8.34375 11.0742 8.82812 10.9883C9.3125 10.8984 9.7793 10.7793 10.2285 10.6309V6.18945Z" fill="currentColor"/>
</svg>
`;

  private iconCss = svg`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.1677 14.175V22L21 9.825H16.988V2L11 14.175H15.1677Z" style="fill: var(--element-active-color)"/>
<path d="M10.2285 6.18945H6.83008V7.70117H8.45312V9.48828C8.29688 9.51562 8.12891 9.54297 7.94922 9.57031C7.77344 9.59375 7.55664 9.60547 7.29883 9.60547C6.77148 9.60547 6.34375 9.48438 6.01562 9.24219C5.6875 8.99609 5.44727 8.6582 5.29492 8.22852C5.14258 7.79492 5.06641 7.29883 5.06641 6.74023C5.06641 6.15039 5.17188 5.63867 5.38281 5.20508C5.59766 4.76758 5.89844 4.42773 6.28516 4.18555C6.67578 3.94336 7.13477 3.82227 7.66211 3.82227C8.0293 3.82227 8.38086 3.86719 8.7168 3.95703C9.05273 4.04688 9.35156 4.1582 9.61328 4.29102L10.2168 2.83789C9.85742 2.68164 9.45703 2.55469 9.01562 2.45703C8.57422 2.35938 8.12695 2.31055 7.67383 2.31055C6.71289 2.31055 5.89844 2.49023 5.23047 2.84961C4.56641 3.20898 4.06055 3.7168 3.71289 4.37305C3.36914 5.0293 3.19727 5.80664 3.19727 6.70508C3.19727 7.66211 3.35156 8.46875 3.66016 9.125C3.96875 9.78125 4.41992 10.2773 5.01367 10.6133C5.60742 10.9492 6.33008 11.1172 7.18164 11.1172C7.79492 11.1172 8.34375 11.0742 8.82812 10.9883C9.3125 10.8984 9.7793 10.7793 10.2285 10.6309V6.18945Z" style="fill: var(--element-active-color)"/>
</svg>
`;

  override render() {
    return html`
      <div class="wrapper">${this.useCssColor ? this.iconCss : this.icon}</div>
    `;
  }

  static override styles = css`
    .wrapper {
      height: 100%;
      width: 100%;
      line-height: 0;
    }
    .wrapper > * {
      height: 100%;
      width: 100%;
    }
  `;
}

declare global {
  interface HTMLElementTagNameMap {
    'obi-generator': ObiGenerator;
  }
}
